import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { AuthService } from '../../services/auth.service';
import * as moment from 'moment';
import { MfaModel } from '../../models/account-ledger.model';

@Component({
  selector: 'app-mfa-authentication',
  templateUrl: './mfa-authentication.component.html',
  styleUrls: ['./mfa-authentication.component.css']
})
export class MfaAuthenticationComponent implements OnInit {

  OTPCode: string;
  updateMfaModel: MfaModel = <MfaModel>{};
  isValidOTP = false;
  counter: string;
  validTime = 300;
  timeLeft: number;

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<MfaAuthenticationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.timeLeft = this.validTime; // initialize timer
    this.startTimer();
  }

  validateOTP() {

    if (!this.OTPCode) {
      this.commonService.implementToast('Please enter 6 digits OTP Code', 'Info');
      return;
    }

    this.authService.validateMfaCode(this.OTPCode).subscribe((isvalid: any) => {
      this.isValidOTP = isvalid;

      if (!this.isValidOTP) {
        this.commonService.implementToast('You entered an incorrect OTP, please try again.', 'Info');
        return;
      }
      this.dialogRef.close(this.isValidOTP); // return if OTP is valid
    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Unable to validate OTP, please try again later.', 'Error');
    });

  }

  resendOTP() {
    const mfaType = this.data.sendMethod.charAt(0).toUpperCase();
    this.updateMfaModel.mfaEnabled = mfaType;
    this.updateMfaModel.mobile = this.data.mobile;
    this.updateMfaModel.email = this.data.email;
    this.authService.sendMfaRegistrationCode(this.updateMfaModel).subscribe((res: any) => {
      if (res === true) {
        this.timeLeft = this.validTime;
        this.startTimer();
      } else {
        this.commonService.implementToast('Unable to resend OTP, please try again later.', 'Error');
      }

    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Unable to resend OTP, please try again later.', 'Error');
    });

  }

  startTimer() {
    const countDownDate = moment().add(this.timeLeft, 'seconds');
    const timer = setInterval(() => {
      const diff = countDownDate.diff(moment());

      if (diff <= 0) {
        clearInterval(timer);
        this.timeLeft = 0;
      } else {
        this.counter = moment.utc(diff).format('mm:ss');
      }

    }, 1000);
  }

  onCloseClick() {
    this.dialogRef.close(false);
  }

}
